// Description: This mixin contains the list of locales that are used in the app.

export default {
  data: () => ({
    locales: [
      'en',
      'fi',
      'fr',
      'de',
      'es',
      'sv',
    ],
  }),
  computed: {
    localesOptions() {
      return this.locales.map(locale => ({
        value: locale,
        text: this.$t(`common.languages.${locale}`),
      }));
    },
  },
};
